import { v4 as uuidv4 } from 'uuid';
import { Tooltip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { SecondaryNodeColor, INodeHandle, BorderStyle } from 'types';
import { countTooltipLabel } from 'utils';

import * as S from './SecondaryNode.styled';

type IProps = {
  data: {
    label: string;
    color: SecondaryNodeColor;
    handle: INodeHandle[];
    borderStyle?: BorderStyle;
    summaryCount?: [number, number, number];
  };
  selected: boolean;
};

export const SecondaryNode = ({
  data: { label, color, borderStyle, summaryCount, handle },
  ...rest
}: IProps) => (
  <>
    {handle.map(({ position, type }, index) => (
      <S.Handle
        color={color as SecondaryNodeColor}
        key={position}
        position={position}
        type={type}
        id={String(index)}
      >
        <ArrowForwardIcon />
      </S.Handle>
    ))}
    <S.Container
      color={color as SecondaryNodeColor}
      borderStyle={borderStyle}
      selected={rest.selected}
    >
      <S.Label>{label}</S.Label>
      <S.SummaryCountContainer>
        {summaryCount?.map((count, index) => (
          <Tooltip
            title={`${countTooltipLabel(index)} results`}
            key={`summaryCount-${uuidv4()}`}
            arrow
          >
            <S.SummaryCount>{count}</S.SummaryCount>
          </Tooltip>
        ))}
      </S.SummaryCountContainer>
    </S.Container>
  </>
);
